import actionTypes from "./actionTypes";
import initialState from "./initialState";

const themeReducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.THEME :{ 
            return{
            ...state,
            theme:!state.theme
        }}
        default:{
            return state;
        }
    }
}

export default themeReducer;